module.exports = __webpack_public_path__ + "img/DiHS_Video_Icon_Lu_Meldung2.ae306749.png";